module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/TWINT-afdc4a3d21cb45b0eb865f632f019920.svg";